import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
};

const themeModeSlice = createSlice({
  name: "themeMode",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setDarkMode: (state) => {
      state.mode = "dark";
    },
    setLightMode: (state) => {
      state.mode = "light";
    },
  },
});

export const { setMode, setDarkMode, setLightMode } = themeModeSlice.actions;

export default themeModeSlice.reducer;
